
import EnhancedMobileOptimizedHero from "@/components/homepage/EnhancedMobileOptimizedHero";

const HeroSection = () => (
  <EnhancedMobileOptimizedHero />
);

export default HeroSection;
